import {Component, Input, inject} from '@angular/core';
import {AppConfigService, LinkPipe} from '@ox/utils';

@Component({
  selector: 'ox-ghost-image',
  templateUrl: './ghost-image.component.html',
  providers: [LinkPipe]
})
export class GhostImageComponent{
  @Input() class = 'img-responsive-fullwidth';
  @Input() altText: string;
  private _srcUrl: string;
  private readonly config: AppConfigService = inject(AppConfigService);

  constructor(private linkPipe: LinkPipe) {}

  @Input() set srcUrl(link: string) {
    this._srcUrl = this.linkPipe.transform(link);
  }

  get srcUrl(): string {
    return this._srcUrl;
  }

  public handleMissingImage(){
    this.srcUrl = this.config.appSettings.moduleConfig.ghostImageURL;
  }
}
